"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ronago": {
    "5f7a1430": [{
      "hkey": "60310ae9",
      "slug": "uggiate-con-ronago",
      "name": "Uggiate con Ronago",
      "primary": true,
      "skipSearch": false
    }],
    "ronago": [{
      "hkey": "60310ae9",
      "slug": "uggiate-con-ronago",
      "name": "Uggiate con Ronago",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;